import { defaultSelectedAccount } from '@/stores/global-filters.utils';
import { getCatalogCategories } from '@/dashboards-v2/constants/catalog-categories.constants';
import { PRODUCT_LINES } from '@/settings/subscription-settings/product-lines';
import { i18n_t as $t } from '@utils/i18n';

const DEFAULT_POLL_DEFINITION = Object.freeze({
    sinceGuideCreation: false,
    dateRange: { type: 'Last 30 Days' },
    guideId: null,
    pollId: null,
    segmentId: 'everyone',
    // NEW FOR V2
    languageCode: '*',
    account: defaultSelectedAccount,
});

export const getDefaultPollDefinition = (overrides = {}) => ({
    ...DEFAULT_POLL_DEFINITION,
    ...overrides,
});

const getPollWidgetBase = (guideName) => ({
    name: guideName
        ? $t('pollResultsWidget.Poll Results {guideName}', { guideName })
        : $t('pollResultsWidget.Poll Results'),
    type: 'pollResults',
    description: $t('pollResultsWidget.Choose a specific poll + poll question to see results summarized.'),
});

export const getDefaultPollWidget = ({ guideName, ...rest } = {}) => ({
    ...getPollWidgetBase(guideName),
    definition: getDefaultPollDefinition(rest),
});

export const getPollWidgetCatalogSettings = () =>
    Object.freeze({
        ...getPollWidgetBase(),
        settings: getDefaultPollDefinition(),
        image: 'poll-results.png',
        categories: [getCatalogCategories().GUIDES],
        productLines: [PRODUCT_LINES.GUIDES],
    });
